// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {Component, signal, ViewEncapsulation} from '@angular/core';
import {HeaderDataService} from "../../services/header_data.service";
import {AppScope} from "../../services/app_scope.service";
import {takeUntil} from "rxjs";
import {BaseComponent} from '../../shared/base.component';
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {CommonModule} from "@angular/common";
import {StringDatePipe} from "../../shared/pipes";

@Component({
    selector: 'print-content',
    templateUrl: './print-content.component.html',
    styleUrls: ['./print-content.component.scss'],
    imports: [
        CommonModule,
        StringDatePipe
    ],
    encapsulation: ViewEncapsulation.None
})
export class PrintContentComponent extends BaseComponent {
    wireLogoSrc = signal('/static/images/wire-logo-black.png')
    clientLogoSrc = signal('')
    printing = false;

    constructor(public headerData: HeaderDataService,
                public dateInst: DateTimeInstanceService,
                public appScope: AppScope) {
        super();
        this.headerData.pagePrinting.pipe(takeUntil(this.onDestroy)).subscribe(value => {
            this.printing = value;
            // Only set the logo URL when actually printing
            if (value) {
                this.clientLogoSrc.set('/admin/myfiles/download/right-logo.png');
            } else {
                this.clientLogoSrc.set('');
            }
        });
    }
    currentDate(): Date {
        return new Date();
    }
}
